import React from 'react';

import careersIllustration from '../assets/careers-illustration.png';

export function CareersIllustration() {
  return (
    <img
      src={careersIllustration}
      width={260}
      height={392}
      alt="Illustration"
    />
  );
}
